<template>
    <tr>
        <td>
            <img :src="productImage"
                 style="width:30px;border:1px solid #ddd;border-radius:5px;">
        </td>
        <td>
            <span class="cart-pro-name">
                {{ cart.name }}
            </span>
            <span class="cart-pro-price">
                 <template v-if="Boolean(Number(cart.default_discount))">
                    <del style="color:#ff0000">&#2547; {{ cart.sell_price }}</del>
                    <strong>
                        &#2547; {{ Number(Number(cart.sell_price) - Number(cart.default_discount)).toFixed(2) }}
                    </strong>
                 </template>
                <template v-else>
                    <strong>&#2547;{{ Number(cart.sell_price).toFixed(2) }}</strong>
                </template>
            </span>
        </td>
        <td>
            <div class="input-group input-group-cart spinner">
                <input type="text"
                       class="form-control"
                       min="1"
                       max="100"
                       :value="cart.quantity"
                       @keyup="checkForAllowedQuantity($event.target.value, cart.id)"
                >
                <div class="input-group-btn-vertical">
                    <button class="btn btn-secondary"
                            type="button"
                            @click="increaseQuantity()">
                        <i class="fa fa-caret-up"></i>
                    </button>
                    <button class="btn btn-secondary"
                            type="button"
                            @click="decreaseQuantity(cart.id)">
                        <i class="fa fa-caret-down"></i>
                    </button>
                </div>
            </div>
        </td>
        <td>
            <span class="cart-pro-price">
                 <template v-if="Boolean(Number(cart.default_discount))">
                    <del style="color:red;display:block;line-height:1">&#2547; {{ Number(subtotal).toFixed(2) }}</del>
                    <strong style="line-height:1">&#2547; {{ Number(subtotalWithDiscount).toFixed(2) }}</strong>
                 </template>
                <template v-else>
                     <strong style="line-height:1">&#2547; {{ Number(subtotal).toFixed(2) }}</strong>
                </template>
            </span>
        </td>
        <td>
            <a href="#" style="color:red;" @click="removeFromCart">
                <span class="remove-pro">
                    <i class="icofont-bin"></i>
                </span>
            </a>
        </td>
    </tr>
</template>

<script>
    import {optional} from "../app/Helpers/Helpers";
    import {mapState} from "vuex";

    export default {
        name: "CartItem",
        props: {
            cart: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        methods: {
            checkForAllowedQuantity(value) {
                let q = 1;
                if (!isNaN(Number(value)) && Number(value) > 0 && Number(value) < 99) {
                    q = Number(value);
                } else if (Number(value) > 99) {
                    q = 99;
                }
                this.setQuantity(q);
            },
            increaseQuantity() {
                let increased = Number(this.cart.quantity) + 1;
                if (increased >= 99) {
                    increased = 99;
                }
                this.setQuantity(increased);
            },
            decreaseQuantity() {
                let decreased = Number(this.cart.quantity) - 1;
                if (decreased < 1) {
                    decreased = 1;
                }
                this.setQuantity(decreased);
            },
            setQuantity(quantity) {
                const carts = [...this.carts];
                const cart = carts.find(cart => Number(cart.id) === Number(this.cart.id));
                cart.quantity = quantity;
                this.$store.commit('SET_CARTS', carts);
                this.$forceUpdate();
                this.$store.dispatch('updateCartQuantity', {
                    slug: this.cart.slug,
                    quantity
                })
            },
            removeFromCart() {
                this.$store.dispatch('removeFromCart', this.cart.slug)
            }
        },
        computed: {
            ...mapState({
                carts: state => state.cart.carts
            }),
            productImage() {
                return Boolean(optional(this.cart, 'image', 'path')) ?
                    optional(this.cart, 'image', 'path') :
                    '/images/no_image.jpg';
            },
            subtotal() {
                return Number(this.cart.quantity) * Number(this.cart.sell_price);
            },
            subtotalWithDiscount() {
                if (!Number(this.cart.default_discount)) {
                    return this.subtotal;
                }

                return this.subtotal - (Number(this.cart.default_discount) * Number(this.cart.quantity));
            }
        },
    }
</script>

<style scoped>

</style>